<template>
  <basicLayout>
    <div class="container-fluid">
      <div class="row m-1">
        <div class="col">
          <h2>DDEX RELEASES</h2>
        </div>
      </div>

      <div class="row m-1">
        <div class="col-xl-6 mt-2">
          <div class="input-group mb-3">
            <span class="input-group-text">Search...</span>
            <input
              @input="debounce_search"
              :value="search"
              type="text"
              class="form-control"
              placeholder="Release Title, Track Title, Artist, Owner, UPC, ISRC ..." />
            <button
              @click="clear_search"
              class="btn btn-outline-secondary"
              type="button">
              Clear
            </button>
          </div>
        </div>
        <div class="col-xl-6 mt-2">
          <div
            class="btn-group"
            role="group">
            <button
              id="btnGroupDrop1"
              type="button"
              class="btn btn-outline-secondary dropdown-toggle"
              data-bs-toggle="dropdown"
              aria-expanded="false">
              Export
            </button>
            <ul
              class="dropdown-menu"
              aria-labelledby="dropdownMenuLink">
              <li>
                <span
                  @click="download_ddex('selection')"
                  class="dropdown-item">
                  <download-icon
                    size="1.2x"
                    class="custom-class me-2"></download-icon
                  ><span class="d-none d-xl-inline-block ml-1">Export Selection</span
                  ><span class="badge bg-light text-dark ms-2">{{ filtered.length }}</span></span
                >
              </li>
              <li>
                <span
                  @click="download_ddex('all')"
                  class="dropdown-item">
                  <download-icon
                    size="1.2x"
                    class="custom-class me-2"></download-icon
                  ><span class="d-none d-xl-inline-block ml-1">Export All</span
                  ><span class="badge bg-light text-dark ms-2">{{ display_releases.length }}</span></span
                >
              </li>
            </ul>
          </div>
        </div>
      </div>

      {{ releases_count }}

      <div class="row m-1 mb-3">
        <div class="col mt-2">
          <div class="card">
            <div class="card-header">
              <div class="row">
                <div class="col-xl-8">
                  <p>
                    <span class="h5">RELEASES</span>&nbsp;<span class="small text-muted"
                      ><i>click on a release to see all associated selected_releases below.</i>
                    </span>
                  </p>
                </div>
                <div class="col-xl-4 text-end">
                  <span v-if="filtered">{{ filtered.length }} results</span>
                </div>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="col">
                  <table class="table table-sm table-hover border-top">
                    <thead class="table-dark sticky-top">
                      <tr>
                        <th
                          @click="sort_by('release_upc')"
                          role="button"
                          class="w-10">
                          UPC
                          <span v-if="sort_column === 'release_upc' && sort_order === 'desc'"
                            ><chevron-down-icon
                              size="0.9x"
                              class="muted ms-1"></chevron-down-icon
                          ></span>
                          <span v-if="sort_column === 'release_upc' && sort_order === 'asc'"
                            ><chevron-up-icon
                              size="0.9x"
                              class="muted ms-1"></chevron-up-icon
                          ></span>
                        </th>

                        <!-- <th
                              @click="sort_by('track_isrc')"
                              role="button"
                              class="w-10">
                              ISRC
                              <span v-if="sort_column === 'track_isrc' && sort_order === 'desc'"
                                ><chevron-down-icon
                                  size="0.9x"
                                  class="muted ms-1"></chevron-down-icon
                              ></span>
                              <span v-if="sort_column === 'track_isrc' && sort_order === 'asc'"
                                ><chevron-up-icon
                                  size="0.9x"
                                  class="muted ms-1"></chevron-up-icon
                              ></span>
                            </th> -->

                        <!-- owner -->
                        <th
                          @click="sort_by('label')"
                          role="button"
                          class="w-10">
                          Label
                          <span v-if="sort_column === 'label' && sort_order === 'desc'"
                            ><chevron-down-icon
                              size="0.9x"
                              class="muted ms-1"></chevron-down-icon
                          ></span>
                          <span v-if="sort_column === 'label' && sort_order === 'asc'"
                            ><chevron-up-icon
                              size="0.9x"
                              class="muted ms-1"></chevron-up-icon
                          ></span>
                        </th>
                        <!-- title -->
                        <th
                          @click="sort_by('title')"
                          role="button"
                          class="w-10">
                          Release Title
                          <span v-if="sort_column === 'title' && sort_order === 'desc'"
                            ><chevron-down-icon
                              size="0.9x"
                              class="muted ms-1"></chevron-down-icon
                          ></span>
                          <span v-if="sort_column === 'title' && sort_order === 'asc'"
                            ><chevron-up-icon
                              size="0.9x"
                              class="muted ms-1"></chevron-up-icon
                          ></span>
                        </th>
                        <!-- <th
                              @click="sort_by('track_title')"
                              role="button"
                              class="w-10">
                              Track Title
                              <span v-if="sort_column === 'track_title' && sort_order === 'desc'"
                                ><chevron-down-icon
                                  size="0.9x"
                                  class="muted ms-1"></chevron-down-icon
                              ></span>
                              <span v-if="sort_column === 'track_title' && sort_order === 'asc'"
                                ><chevron-up-icon
                                  size="0.9x"
                                  class="muted ms-1"></chevron-up-icon
                              ></span>
                            </th> -->
                        <!-- main_artist -->
                        <th
                          @click="sort_by('main_artists')"
                          role="button"
                          class="w-10">
                          Main Artists
                          <span v-if="sort_column === 'main_artists' && sort_order === 'desc'"
                            ><chevron-down-icon
                              size="0.9x"
                              class="muted ms-1"></chevron-down-icon
                          ></span>
                          <span v-if="sort_column === 'main_artists' && sort_order === 'asc'"
                            ><chevron-up-icon
                              size="0.9x"
                              class="muted ms-1"></chevron-up-icon
                          ></span>
                        </th>
                        <!-- release -->
                        <th
                          @click="sort_by('date')"
                          role="button"
                          class="w-15">
                          Released

                          <span v-if="sort_column === 'date' && sort_order === 'desc'"
                            ><chevron-down-icon
                              size="0.9x"
                              class="muted ms-1"></chevron-down-icon
                          ></span>
                          <span v-if="sort_column === 'date' && sort_order === 'asc'"
                            ><chevron-up-icon
                              size="0.9x"
                              class="muted ms-1"></chevron-up-icon
                          ></span>
                        </th>

                        <!-- preview -->
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="release in filtered"
                        @click="get_selected_releases(release)"
                        :key="release.id"
                        class="align-left"
                        :class="row_class(release)">
                        <td
                          @dblclick="filter_by(release.release_upc)"
                          class="text-truncate">
                          {{ release.release_upc }}
                        </td>
                        <!-- <td><span v-html="release._highlightResult.track_isrc.value"></span></td> -->
                        <td
                          @dblclick="filter_by(release.label)"
                          class="text-truncate">
                          {{ release.label }}
                        </td>
                        <td
                          @dblclick="filter_by(release.title)"
                          class="text-truncate">
                          {{ release.title }}
                        </td>
                        <!-- <td @dblclick="filter_by(release.track_title)">
                              <span v-html="release._highlightResult.track_title.value"></span>
                            </td> -->
                        <td
                          @dblclick="filter_by(release.main_artists)"
                          class="text-truncate">
                          {{ release.main_artists }}
                        </td>
                        <!-- release_date -->
                        <td>{{ release.original_digital_release_date }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="selected_releases.length"
        class="row m-1">
        <div class="col">
          <div class="card">
            <div class="card-header">
              <h5>
                <!-- <img
                      v-if="selected_releases[0].release_art_url"
                      :src="selected_releases[0].release_art_url"
                      :alt="selected_releases[0].release_title"
                      width="40px"
                      loading="lazy" /> -->
                <!-- <span class="ms-3">
                      {{ selected_releases[0].release_main_artist }} - {{ selected_releases[0].release_title }} ({{
                        selected_releases[0].release_upc
                      }})</span
                    > -->
              </h5>
            </div>
            <div class="card-body">
              <table class="table table-bordered table-sm table-hover">
                <thead>
                  <tr>
                    <th scope="col w-5">ISRC</th>
                    <th scope="col w-5">No.</th>
                    <th scope="col w-10">Track Title</th>
                    <th scope="col w-10">Main Artists</th>
                    <th scope="col w-5">Featuring</th>
                    <th scope="col w-5">Released</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="track in selected_releases"
                    :key="track.isrc">
                    <td>{{ track.isrc }}</td>
                    <td>{{ track.track_number }}</td>
                    <td>
                      {{ track.title }} <span v-if="track.subtitle">{{ track.subtitle }}</span>
                    </td>
                    <td>{{ track.main_artists }}</td>
                    <td>{{ track.featured_artists }}</td>
                    <td>{{ track.original_original_release_date }}</td>
                    <td
                      scope="col "
                      class="text-center w-15">
                      {{ track.track_audio_url }}
                      <audio
                        v-if="track.track_audio_url"
                        height="12"
                        controls>
                        <source
                          :src="track.track_audio_url"
                          type="audio/wav"
                          preload="auto" />
                      </audio>
                      <button
                        v-else
                        @click="download_flac(track)"
                        class="btn btn-sm btn-outline-success">
                        <download-icon
                          size="1.0x"
                          class="text-secondary"></download-icon>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="card-footer"></div>
          </div>
        </div>
      </div>

      <!-- <Pagination
        v-if="pages"
        :pages="pages"
        :selected_page="selected_page"
        v-on:updatePage="updatePage" /> -->
    </div>
  </basicLayout>
</template>
    
    <script>
// https://w3lessons.info/bootstrap-fixed-table-header-using-css/
// import { Toast, Modal } from "bootstrap";
//   import { auth } from "@/firebaseConfig.js";
import { state } from "@/store";
import { fb, db, storage } from "@/firebaseConfig";
// import algoliasearch from "algoliasearch";
import { orderBy } from "lodash";
// import Papa from "papaparse";
import basicLayout from "@/components/basicLayout";
import Pagination from "@/components/Pagination";
import filter_mixins from "@/mixins/filter_mixins";
import sort_mixins from "@/mixins/sort_mixins";
import {
  EditIcon,
  EyeIcon,
  TrashIcon,
  ShuffleIcon,
  ImageIcon,
  MusicIcon,
  CopyIcon,
  DownloadIcon,
  CodeIcon,
  ChevronUpIcon,
  ChevronDownIcon,
  MoreHorizontalIcon,
  ThumbsUpIcon,
  ExternalLinkIcon,
  StarIcon,
  ArchiveIcon,
  InfoIcon,
} from "vue-feather-icons";

const releases = db.collection("believe_ddex");
// const selected_releases = db.collection("mtl_selected_releases");

export default {
  name: "my_release_submissions",

  data() {
    return {
      selected_line_id: "",
      display_releases: [],
      selected_releases: [],
      releases_count: 0,
      search: this.$route.query.search || "",
      debounce: null,
      sort_column: ["track_number"],
      sort_order: "asc",
      filters: "",
      page_limit: 10,
      selected_page: 1,
      searchClient: null,
      index: {},
    };
  },

  components: {
    basicLayout,
    Pagination,
    EditIcon,
    EyeIcon,
    TrashIcon,
    ShuffleIcon,
    ImageIcon,
    MusicIcon,
    CodeIcon,
    CopyIcon,
    DownloadIcon,
    ChevronUpIcon,
    ChevronDownIcon,
    MoreHorizontalIcon,
    ThumbsUpIcon,
    ExternalLinkIcon,
    StarIcon,
    ArchiveIcon,
    InfoIcon,
  },
  mixins: [filter_mixins, sort_mixins],

  mounted() {
    let query = releases;
    query = query.limit(500);
    this.$bind("display_releases", query);
  },

  methods: {
    row_class(selected_line) {
      return { "alert alert-secondary": this.selected_line_id === selected_line.release_upc };
    },

    debounce_search(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.search = event.target.value;
      }, 500);
    },

    clear_search() {
      this.search = "";
      this.selected_releases = [];
    },
    sort_by(column) {
      console.log("sorting by " + column);
      this.sort_column = column;
      this.sort_order = this.sort_order === "asc" ? "desc" : "asc";
    },
    filter_by(filter) {
      console.log("FILTER BY: " + filter);
      this.search = filter;
    },
    updatePage(value) {
      this.selected_page = value;
      this.selected_releases = [];
    },

    get_selected_releases(release) {
      this.selected_line_id = release.release_upc;
      console.log(release.release_upc);
      this.$bind("selected_releases", releases.where("release_upc", "==", release.release_upc).orderBy("track_number"));
    },

    download_flac: async function (track) {
      console.log(track);

      const storageRef = storage.ref();
      console.log(`mtl_audio_tracks/${track.file_name}`);
      const mtlRef = storageRef.child(`mtl_audio_tracks/${track.file_name}`);

      const download_url = await mtlRef.getDownloadURL();

      console.log(download_url);

      // let res = await fetch(download_url);
      track.track_audio_url = download_url;
    },

    download_release: async function (release) {
      let download_release = this.display_tracks
        .filter((track) => (track.release_id = release.id))
        .map((track) => {
          let release_track = { ...track };
          release_track.track_main_artists = track.track_main_artists.map((artist) => artist.name).join("; ");
          release_track.track_featured_artists = track.track_featured_artists.map((artist) => artist.name).join("; ");
          release_track.track_remix_artists = track.track_remix_artists.map((artist) => artist.name).join("; ");
          release_track.track_lyricists = track.track_lyricists.map((lyricist) => lyricist.name).join("; ");
          release_track.track_composers = track.track_composers.map((composer) => composer.name).join("; ");
          release_track.track_producers = track.track_producers.map((producer) => producer.name).join("; ");
          return { ...release, ...release_track };
        });

      const csv = Papa.unparse({
        fields: [
          "release_title",
          "release_main_artist",
          "release_label",
          "release_genre",
          "release_subgenre",
          "release_parental_advisory",
          "release_release_date",
          "release_original_release_date",
          "release_production_year",
          "release_production_owner",
          "release_copyright_owner",
          "release_upc",
          "release_art_url",
          "track_isrc",
          "track_title",
          "track_subtitle",
          "track_version_title",
          "track_title_language",
          "track_main_artists",
          "track_featured_artists",
          "track_remix_artists",
          "track_composers",
          "track_lyricists",
          "track_producers",
          "track_producers",
          "track_genre",
          "track_type",
          "track_lyric_language",
          "track_parental_advisory",
          "track_price_tier",
          "track_audio_url",
          "is_submitted_to_drm",
          "is_approved_by_drm",
          "is_submitted_to_believe",
          "is_approved_by_believe",
          "is_submitted_to_youtube",
          "is_approved_by_youtube",
        ],
        data: download_release,
        quotes: true,
      });
      const csv_name = `${release.id}.csv`;

      console.log(csv_name);
      this.downloading = false;
      const anchor = document.createElement("a");
      anchor.href = "data:text/csv," + encodeURIComponent(csv);
      anchor.download = csv_name;
      anchor.click();
    },
  },

  watch: {
    page: {
      handler(page, old_page) {
        if (page !== old_page) {
          this.selected_releases = [];
        }
      },
    },

    search: {
      handler(search, old_search) {
        if (search !== old_search) {
          this.selected_page = 1;
          this.selected_releases = [];
        }
      },
      immediate: true,
    },

    //   userProfile: {
    //     immediate: true,
    //     handler(profile) {
    //       this.get_tracks(profile);
    //     },
    //   },
  },

  computed: {
    filtered() {
      let visible_releases = this.display_releases;

      let search = this.search;

      if (this.sort_column) {
        visible_releases = orderBy(visible_releases, this.sort_column || "", this.sort_order);
      }

      visible_releases = visible_releases.filter((release) => {
        const s = release.title + release.release_upc + release.isrc;
        const su = s.toUpperCase();
        return su.match(search.toUpperCase());
      });

      const start = (this.selected_page - 1) * this.page_limit;
      const end = start + this.page_limit;
      visible_releases = visible_releases.slice(start, end);

      return visible_releases;
    },

    pages() {
      const pages_array = this.search ? this.filtered : this.display_releases;
      return Math.ceil(pages_array.length / this.page_limit);
    },

    userProfile() {
      return state.userProfile;
    },
    isAdmin() {
      return this.userProfile.role === "admin" || this.userProfile.role === "superadmin";
    },
  },
};
</script>
  
  <style >
.table > tbody > tr > td {
  vertical-align: middle;
}

td em {
  font-style: normal;
  font-weight: bold;
  background-color: #ceece5;
  padding-top: 0.15rem;
  padding-bottom: 0.15rem;
}

.routerlink {
  display: inline-block;
  text-decoration: none;
}
.btn-block {
  width: 100%;
}

audio {
  height: 32px;
}
</style>
    